import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

/**
 * Closes the host's associated open panel (e.g. the mobile nav) when the
 * user clicks outside it or presses Escape, and returns focus to the
 * triggering element — mirrors the original script.js mobile-menu behaviour.
 */
@Directive({
  selector: '[demoClosePanel]',
  standalone: true,
})
export class ClosePanelDirective {
  @Input({ required: true }) demoClosePanelOpen = false;
  @Input() demoClosePanelTrigger: HTMLElement | null = null;
  @Input() demoClosePanelClose: () => void = () => {};

  private readonly host = inject(ElementRef<HTMLElement>);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.demoClosePanelOpen) {
      return;
    }
    const target = event.target as Node;
    const clickedTrigger = this.demoClosePanelTrigger?.contains(target);
    if (!this.host.nativeElement.contains(target) && !clickedTrigger) {
      this.demoClosePanelClose();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (!this.demoClosePanelOpen) {
      return;
    }
    this.demoClosePanelClose();
    this.demoClosePanelTrigger?.focus();
  }
}
